import { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";

//Props Validations
import PropTypes from "prop-types";

//import assets

// import component
import Loader from "../../common/Loader";
import FilterAcrossProductsToggleComponent from "../../common/FilterAcrossProductsToggleComponent";
import Reset from "../../common/Reset";
import WeightToggleComponent from "../../common/WeightToggleComponent";
import TTestDialog from "../../common/TTest/TTestDialog";
import BeautyAndWellbeingTTestDialog from "components/common/TTest/BeautyAndWellbeingTTestDialog";
import AnalysisTypeSelector from "../../common/AnalysisTypeSelector";

// redux
import { useSelector, useDispatch } from "react-redux";
import { toggleTextThemeSelection } from "store/features/textThemeSlice";
import {
    loadClaimsAnalysisResultState,
    loadIsClaimsAnalysisResultLoadingState,
    loadJustRightAnalysisResultState,
    loadDefaultJustRightAnalysisResultState,
    loadIsJustRightAnalysisResultLoadingState,
    loadAgreementAnalysisResultState,
    loadIsAgreementAnalysisResultLoadingState,
    loadOverallAnalysisResultState,
    loadIsOverallAnalysisResultLoadingState,
    loadSecondaryAnalysisResultState,
    loadIsSecondaryAnalysisResultLoadingState,
    loadIsItmDataState,
    loadDefaultAgreementAnalysisResultState,
    loadDefaultOverallAnalysisResultState,
    loadDefaultSecondaryAnalysisResultState,
    loadDefaultClaimsAnalysisResultState,
} from "store/features/analysisResultsSlice";
import { resetTTestStore } from "store/features/ttestSlice";

import GetAgreementResult from "utils/apis/GetAgreementResult";
import GetOverallResult from "utils/apis/GetOverallResult";
import GetSecondaryResult from "utils/apis/GetSecondaryResult";
import GetClaimsResult from "utils/apis/GetClaimsResult";
import GetJustRightResult from "utils/apis/GetJustRightResult";
import OverallToggleComponent from "../../common/OverallToggleComponent";
import ItmToggleComponent from "components/common/ItmToggleComponent";
import ViewToggle from "components/common/ViewToggle";
import InitialPopup from "../../common/InitialPopup";
import AnalysisTable from "../../common/analysisModule/AnalysisTable";
import AnalysisChart from "../../../components/common/analysisModule/chart/AnalysisChart";
import AbsoluteCounts from "../../common/analysisModule/AbsoluteCounts";

function PerformanceTab({ dataMappingData = {} }) {
    const navigate = useNavigate();

    const productsOrder = useSelector((state) => state.productsInfoStore.productsOrder);
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const productCategoryId = productCategoryData?.value || null;

    //REDUX
    const dispatch = useDispatch();
    const selectedStudy = useSelector((state) => state.studyDataStore.selectedStudies);
    const isConsumerFilterSelected = useSelector((state) => state.consumerFilterStore.filterSelectionStatus);

    const productsSecondaryDataState = useSelector((state) => state.analysisResultsStore.overallAnalysisResult);
    const isLoading = useSelector((state) => state.analysisResultsStore.isOverallAnalysisResultLoading);
    const weightToggle = useSelector((state) => state.analysisResultsStore.weightToggle);
    const isITMDataShown = useSelector((state) => state.analysisResultsStore.isItmDataShown);
    // const dataView = useSelector((state) => state.analysisResultsStore.dataView); //! for deodorant only mean, for orthers default is mean

    const overallBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.overallBoxAnalysisSelection);
    const secondaryBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.secondaryBoxAnalysisSelection);
    const agreementBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.agreementBoxAnalysisSelection);
    const claimsBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.claimsBoxAnalysisSelection);

    // toggle table and chart
    const [isTableShown, setIsTableShown] = useState(true);

    // t-test details

    const [tTestResult, setTTestResult] = useState([]);
    const [testLabel, setTestLabel] = useState("");

    // Analysis type
    const analysisTypeValue = useSelector((state) => state.analysisTypeSelectionStore.overallAnalysisTypeValue);
    const boxAnalysisTypeSelection = useSelector((state) => state.analysisTypeSelectionStore.overallBoxAnalysisTypeSelection);

    const [isFisher, setIsFisher] = useState(false);
    const [legends, setLegends] = useState([]);

    const isDeodorants = process.env?.REACT_APP_DEODORANTS?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isOralCare = process.env?.REACT_APP_ORAL_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCleansing = process.env?.REACT_APP_SKIN_CLEANSING?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const jarOrJustRightVariableCategory = isHairCare || isSkinCare ? "JAR" : "Just Right";
    const isBeautyAndWellbeing = isHairCare || isSkinCare;
    const clearResult = () => {
        setTTestResult([]);
        setTestLabel("");
        dispatch(resetTTestStore());
        dispatch(toggleTextThemeSelection([])); 
        // onTTestDataReceived(false, "", "", "", null, "");
    };

    // clear T Test
    useEffect(() => {
        clearResult();
    }, [weightToggle]);

    useEffect(() => {
        if (isOralCare || isSkinCleansing) {
            if (!isLoading) {
                if (!isConsumerFilterSelected) {
                    InitialPopup.general();
                }
            }
        }
    }, [isLoading]);

    const clearTtest = (product, type) => {
        // clear t test
        if (type === "consumerFilterAll") {
            clearResult();
        } else if (type === "consumerFilter") {
            const tTestPro = tTestResult?.[0]?.colors?.map((datum) => datum.productCode) || [];
            const cfPc = product?.split("_")?.join(" ") || "";
            if (tTestPro.indexOf(cfPc) !== -1) {
                clearResult();
            }
        }
    };

    const getOverallResult = async ({ product = null, coreDataId = null, type = null, consumerFilter = null, pcs = [], selectedStudy = [], allAnalysisData = {}, fetchOnlyCurrent = false, boxAnalysisSelection = {} }) => {
        clearTtest(product, type);
        // current page data
        dispatch(loadIsOverallAnalysisResultLoadingState(true));
        dispatch(loadIsSecondaryAnalysisResultLoadingState(true));
        dispatch(loadIsAgreementAnalysisResultLoadingState(true));
        dispatch(loadIsClaimsAnalysisResultLoadingState(true));

        const overallResult = await GetOverallResult({ product, coreDataId, type, consumerFilter, pcs, selectedStudy, productsSecondaryDataState: allAnalysisData?.overallAnalysisResult || [], productsOrder, productCategoryId, boxAnalysisSelection: boxAnalysisSelection["overall"] });
        if (overallResult) {
            overallResult.forEach((product) => {
                product.scores.forEach((ele) => {
                    if (ele.backendVariable.includes("ITM_") && ele.mean) {
                        dispatch(loadIsItmDataState(true));
                    }
                });
            });
            dispatch(loadOverallAnalysisResultState([...overallResult]));
            if (!type) {
                dispatch(loadDefaultOverallAnalysisResultState([...overallResult]));
            }
        }
        dispatch(loadIsOverallAnalysisResultLoadingState(false));

        //other pages data

        const secondaryResult = await GetSecondaryResult({ product, coreDataId, type, consumerFilter, pcs, selectedStudy, productsSecondaryDataState: allAnalysisData?.secondaryAnalysisResult || [], productsOrder, productCategoryId, boxAnalysisSelection: boxAnalysisSelection["secondary"] });
        if (secondaryResult) {
            dispatch(loadSecondaryAnalysisResultState([...secondaryResult]));
            if (!type) {
                dispatch(loadDefaultSecondaryAnalysisResultState([...secondaryResult]));
            }
        }
        // product = null, coreDataId = null, type = null, consumerFilter = null, pcs = [], selectedStudy = [], productsSecondaryDataState = null, order = [], productCategoryId = null
        const agreementResult = await GetAgreementResult({ product, coreDataId, type, consumerFilter, pcs, selectedStudy, productsSecondaryDataState: allAnalysisData?.agreementAnalysisResult || [], productsOrder, productCategoryId, boxAnalysisSelection: boxAnalysisSelection["agreement"] });
        if (agreementResult) {
            dispatch(loadAgreementAnalysisResultState([...agreementResult]));
            if (!type) {
                dispatch(loadDefaultAgreementAnalysisResultState([...agreementResult]));
            }
        }

        const claimsResult = await GetClaimsResult({ product, coreDataId, type, consumerFilter, pcs, selectedStudy, productsSecondaryDataState: allAnalysisData?.claimsAnalysisResult || [], productsOrder, productCategoryId, boxAnalysisSelection: boxAnalysisSelection["claims"] });
        if (claimsResult) {
            dispatch(loadClaimsAnalysisResultState([...claimsResult]));
            if (!type) {
                dispatch(loadDefaultClaimsAnalysisResultState([...claimsResult]));
            }
        }

        if (!isDeodorants) {
            dispatch(loadIsJustRightAnalysisResultLoadingState(true));
            const justRightResult = await GetJustRightResult(product, coreDataId, type, consumerFilter, pcs, selectedStudy, allAnalysisData?.justRightAnalysisResult || [], productsOrder, productCategoryId, jarOrJustRightVariableCategory);
            dispatch(loadJustRightAnalysisResultState([...justRightResult]));
            if (!type) {
                dispatch(loadDefaultJustRightAnalysisResultState([...justRightResult]));
            }
            dispatch(loadIsJustRightAnalysisResultLoadingState(false));
        }

        dispatch(loadIsAgreementAnalysisResultLoadingState(false));
        dispatch(loadIsSecondaryAnalysisResultLoadingState(false));
        dispatch(loadIsClaimsAnalysisResultLoadingState(false));
        console.log("fetchOnlyCurrent", fetchOnlyCurrent);
    };

    useEffect(() => {
        async function fetchAnalysisResult() {
            await getOverallResult({
                product: null,
                coreDataId: null,
                type: null,
                consumerFilter: null,
                pcs: [],
                selectedStudy,
                allAnalysisData: [],
                fetchOnlyCurrent: true,
                boxAnalysisSelection: {
                    overall: overallBoxAnalysisSelection,
                    secondary: secondaryBoxAnalysisSelection,
                    agreement: agreementBoxAnalysisSelection,
                    claims: claimsBoxAnalysisSelection,
                },
            });
        }
        if (selectedStudy.length === 0) {
            navigate("/studies");
        } else if (!productsSecondaryDataState.length) {
            fetchAnalysisResult();
        }
    }, [selectedStudy]);

    const returnComponent = () => {
        if (Object.keys(dataMappingData).length !== 0 && dataMappingData?.columns) {
            if (isTableShown) {
                return (
                    <>
                        <AnalysisTable
                            productsSecondaryData={productsSecondaryDataState}
                            handleFilterSubmit={getOverallResult}
                            selectedStudy={selectedStudy}
                            analysisLevelData={{
                                tableConfig: {
                                    stickyColumns: ["Attribute", "Attribute Area"],
                                },
                                isITMDataShown: isITMDataShown,
                                moduleName: "overall",
                                analysisTypeValue: analysisTypeValue,
                                boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                                boxAnalysisSelection: overallBoxAnalysisSelection,
                                mappings: dataMappingData.columns,
                                // boxAnalysisSelection:boxAnalysisSelection,
                            }}
                            tTest={{
                                tTestLegends: legends,
                                isFisher: isFisher,
                                tTestResult: tTestResult,
                                testLabel: testLabel,
                            }}
                            // onTextThemeSelectionChange={onTextThemeSelectionChange}
                        />
                        {/* <OverallTable
                            productSelected={productsRow}
                            productsSecondaryData={productsSecondaryDataState}
                            dataMappingData={dataMappingData.columns}
                            column1={dataMappingData.columns.map((col) => col.macroCategory)}
                            column2={dataMappingData.columns}
                            tTestResult={tTestResult}
                            keyMapDisplayLabelConsumerFilter={keyMapDisplayLabelConsumerFilter}
                            testLabel={testLabel}
                            handleFilterSubmit={getOverallResult}
                            selectedStudy={selectedStudy}
                            isITMDataShown={isITMDataShown}
                        /> */}
                    </>
                );
            } else if (dataMappingData?.columns && isITMDataShown) {
                return (
                    <>
                        <div
                            style={{
                                minHeight: "calc(-300px + 100vh)",
                                display: "flex",
                                justifyContent: "space-between",
                                height: "100%",
                            }}
                        >
                            <div
                                style={{
                                    width: "49%",
                                    // float: "left",
                                    // position: "relative",
                                    borderTop: "1px solid #c8c8c8",
                                    borderRight: "1px solid #c8c8c8",
                                    paddingTop: "20px",
                                    marginTop: "10px",
                                    height: "100%",
                                }}
                            >
                                <div
                                    style={{
                                        textAlign: "center",
                                        marginBottom: "20px",
                                    }}
                                >
                                    ITM
                                </div>
                                <AnalysisChart
                                    productsSecondaryData={productsSecondaryDataState}
                                    analysisLevelData={{
                                        isITMDataShown: isITMDataShown,
                                        moduleName: "overall",
                                        analysisTypeValue: analysisTypeValue,
                                        boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                                        boxAnalysisSelection: overallBoxAnalysisSelection,
                                        mappings: dataMappingData.columns,
                                    }}
                                    tTest={{
                                        tTestLegends: legends,
                                        isFisher: isFisher,
                                        tTestResult: tTestResult,
                                        testLabel: testLabel,
                                    }}
                                />
                                {/* <AnalysisChart
                                    key={"itm"}
                                    productSelected={productsRow}
                                    productsSecondaryData={productsSecondaryDataState}
                                    column1={dataMappingData.columns.map((col) => col.macroCategory)}
                                    column2={JSON.parse(JSON.stringify(dataMappingData.columns))}
                                    tTestResult={tTestResult}
                                    chartType={chartType}
                                    analysisType={"overallKpiAnalysis"}
                                    componentName={"overallKpiDataState"}
                                    pageName={"overallKpiAnalysis"}
                                    colorsType={"overAllKPI"}
                                    legends={legends}
                                    selectedStudy={selectedStudy}
                                    testLabel={testLabel}
                                    removedList={itmRemovedList}
                                    // totalDMD={JSON.parse(JSON.stringify(dataMappingsForTable.columns))}
                                    itmFlag={true}
                                    dataView={dataView}
                                /> */}
                            </div>
                            <div
                                style={{
                                    width: "49%",
                                    // float: "left",
                                    // position: "relative",
                                    borderTop: "1px solid #c8c8c8",
                                    borderRight: "1px solid #c8c8c8",
                                    paddingTop: "20px",
                                    marginTop: "10px",
                                    height: "100%",
                                }}
                            >
                                <div
                                    style={{
                                        textAlign: "center",
                                        marginBottom: "20px",
                                    }}
                                >
                                    Recall
                                </div>
                                <AnalysisChart
                                    productsSecondaryData={productsSecondaryDataState}
                                    analysisLevelData={{
                                        moduleName: "overall",
                                        analysisTypeValue: analysisTypeValue,
                                        boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                                        boxAnalysisSelection: overallBoxAnalysisSelection,
                                        mappings: dataMappingData.columns,
                                    }}
                                    tTest={{
                                        tTestLegends: legends,
                                        isFisher: isFisher,
                                        tTestResult: tTestResult,
                                        testLabel: testLabel,
                                    }}
                                />
                                {/* <AnalysisChart
                                    key={"recall"}
                                    productSelected={productsRow}
                                    productsSecondaryData={productsSecondaryDataState}
                                    dataMappingData={dataMappingData}
                                    column1={dataMappingData.columns.map((col) => col.macroCategory)}
                                    column2={JSON.parse(JSON.stringify(dataMappingData.columns))}
                                    tTestResult={tTestResult}
                                    chartType={chartType}
                                    analysisType={"overallKpiAnalysis"}
                                    componentName={"overallKpiDataState"}
                                    pageName={"overallKpiAnalysis"}
                                    colorsType={"overAllKPI"}
                                    legends={legends}
                                    selectedStudy={selectedStudy}
                                    testLabel={testLabel}
                                    removedList={removedList}
                                    column2ForItm={JSON.parse(JSON.stringify(dataMappingData.columns))}
                                    type="Both"
                                    dataView={dataView}
                                /> */}
                            </div>
                        </div>
                        {/* <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end", // Changed from "space-between" to "flex-end"
                                position: "sticky",
                                left: 0,
                            }}
                        >
                            <p
                                style={{
                                    marginBottom: 0,
                                    color: "#495057",
                                    fontWeight: 600,
                                    fontSize: 14,
                                }}
                            >
                                Likert scale size is indicated in brackets () next to each variable
                            </p>
                        </div> */}
                    </>
                );
            } else {
                return (
                    <>
                        <AnalysisChart
                            productsSecondaryData={productsSecondaryDataState}
                            analysisLevelData={{
                                moduleName: "overall",
                                analysisTypeValue: analysisTypeValue,
                                boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                                boxAnalysisSelection: overallBoxAnalysisSelection,
                                mappings: dataMappingData.columns,
                            }}
                            tTest={{
                                tTestLegends: legends,
                                isFisher: isFisher,
                                tTestResult: tTestResult,
                                testLabel: testLabel,
                            }}
                        />
                        {/* <AnalysisChart
                            productSelected={productsRow}
                            productsSecondaryData={productsSecondaryDataState}
                            // dataMappingData={dataMappingsForTable}
                            // column1={dataMappingsForTable.columns.map((col) => col.macroCategory)}
                            // column2={dataMappingsForTable.columns}
                            tTestResult={tTestResult}
                            chartType={chartType}
                            analysisType={"overallKpiAnalysis"}
                            componentName={"overallKpiDataState"}
                            pageName={"overallKpiAnalysis"}
                            colorsType={"overAllKPI"}
                            legends={legends}
                            selectedStudy={selectedStudy}
                            testLabel={testLabel}
                            removedList={removedList}
                            dataView={dataView}
                        /> */}
                        {/* <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end", // Changed from "space-between" to "flex-end"
                                position: "sticky",
                                left: 0,
                            }}
                        >
                            <p
                                style={{
                                    marginBottom: 0,
                                    color: "#495057",
                                    fontWeight: 600,
                                    fontSize: 14,
                                }}
                            >
                                Likert scale size is indicated in brackets () next to each variable
                            </p>
                        </div> */}
                    </>
                );
            }
        }
        return null;
    };

    return (
        <>
            {isLoading && <Loader />}
            <div
                className="card-btns"
                style={{ padding: "0px 0px", margin: "10px 0px" }}
            >
                <div
                    className=" d-flex"
                    style={{ alignItems: "center" }}
                >
                    <div>
                        <ViewToggle
                            value={isTableShown}
                            setValue={setIsTableShown}
                            labels={["Table", "Chart"]}
                        />
                    </div>
                    {(isDeodorants || isHairCare || isSkinCare) && (
                        <div style={{ marginLeft: "1rem", width: "120px" }}>
                            <ItmToggleComponent />
                        </div>
                    )}
                    <div
                        style={{
                            zIndex: "3",
                            width: "150px",
                            marginLeft: "1rem"
                        }}
                    >
                        <AnalysisTypeSelector
                            value={analysisTypeValue}
                            pageName="overallKpiAnalysis"
                            variableCategory={"KPI (OO),KPI ITM"}
                            mappings={dataMappingData.columns}
                            // itmDataMapping={dataMappingData.columns}
                            handleFilterSubmit={getOverallResult}
                            moduleName="overall"
                            clearResult={clearResult}
                        />
                    </div>
                    {analysisTypeValue?.value === "box_analysis" && isOralCare &&
                        <AbsoluteCounts
                            moduleName="overall"
                        />
                    }
                </div>
                <div>
                    <OverallToggleComponent />
                    <WeightToggleComponent />
                    <FilterAcrossProductsToggleComponent />
                    {isBeautyAndWellbeing ? (
                        <BeautyAndWellbeingTTestDialog
                            variableCategory="KPI (OO)"
                            isITMDataShown={isITMDataShown}
                            functionsSettings={{
                                setIsFisher: setIsFisher,
                                setLegends: setLegends,
                                setTTestResult: setTTestResult,
                                setTestLabel: setTestLabel,
                                clearResult: clearResult,
                                // onTTestDataReceived: onTTestDataReceived,
                            }}
                            analysisLevelData={{
                                moduleName: "overall",
                                analysisTypeValue: analysisTypeValue,
                                boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                                boxAnalysisSelection: overallBoxAnalysisSelection,
                            }}
                            tabData={{
                                productsSecondaryDataState: productsSecondaryDataState,
                            }}
                        />
                    ) : (
                        <TTestDialog
                            variableCategory="KPI (OO)"
                            isITMDataShown={isITMDataShown}
                            functionsSettings={{
                                setIsFisher: setIsFisher,
                                setLegends: setLegends,
                                setTTestResult: setTTestResult,
                                setTestLabel: setTestLabel,
                                clearResult: clearResult,
                                // onTTestDataReceived: onTTestDataReceived,
                            }}
                            analysisLevelData={{
                                moduleName: "overall",
                                analysisTypeValue: analysisTypeValue,
                                boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                                boxAnalysisSelection: overallBoxAnalysisSelection,
                                mappings: dataMappingData.columns,
                            }}
                            tabData={{
                                productsSecondaryDataState: productsSecondaryDataState,
                            }}
                        />
                    )}
                    <Reset clearTTestResult={clearResult} />
                </div>
            </div>
            <div
                style={{
                    minHeight: "calc(100vh - 300px)",
                }}
            >
                {returnComponent()}
            </div>
        </>
    );
}

// Typechecking props for the PerformanceTab
PerformanceTab.propTypes = {
    dataMappingData: PropTypes.object,
};

export default PerformanceTab;
